import * as contactApi from "shadow-client/endpoints/contactApi";
import { CheckoutAccount } from "./CheckoutAccount";
import { compose, lifecycle, withHandlers, withProps, withState } from "recompose";
import { connect } from "react-redux";
import { decodeParam } from "react-router-utils";
import { formatPattern } from "react-router-utils";
import { getCart } from "app/redux/selectors";
import { getCartSaleId } from "app/redux/modules/cart";
import { withTranslator } from "app/decorators";
import Immutable from "immutable";
import _clearCart from "app/redux/actions/clearCart";
import _doPayment from "app/redux/actions/doPayment";
import {
  fetchArticleBehaviorsList as fetchArticleBehaviorsListFn,
  fetchArticleList as fetchArticleListFn
} from "shadow-client/endpoints/saleApi";

const mapStateToProps = state => ({
  saleId: getCartSaleId(getCart(state))
});

function componentWillMount() {
  const { history, saleId, clubId } = this.props;

  if (!saleId) {
    history.push(formatPattern("/:clubId/checkout", { clubId: clubId }));
  }
}

const onSubmit = ({
  clearContactSeach,
  findContactsMatchingQuery,
  findContactMatchingIdentificator,
  searchAccount,
  noCardIdentification
}) => e => {
  e.preventDefault();
  clearContactSeach();

  if (noCardIdentification) {
    findContactsMatchingQuery(searchAccount);
  } else {
    findContactMatchingIdentificator(searchAccount);
  }
};

const findContactsMatchingQuery = ({
  fetchFindContactList,
  setCryptedContacts,
  setIsOpen,
  setIsError,
  setIsFetching
}) => searchParam => {
  setIsFetching(true);
  fetchFindContactList({
    params: {
      givenName: searchParam.givenName,
      familyName: searchParam.familyName,
      status: "client"
    }
  }).then(
    response => {
      const cryptedContactList = Immutable.fromJS(response.data["hydra:member"]);
      setIsFetching(false);
      setCryptedContacts(cryptedContactList);

      if (!cryptedContactList.size) {
        setIsOpen(true);
        setIsError(true);
      }
    },
    () => {
      setIsOpen(true);
      setIsError(true);
    }
  );
};

const findContactMatchingIdentificator = ({
  fetchFindContactList,
  setCryptedContacts,
  setIsOpen,
  setIsError,
  setIsFetching
}) => searchParam => {
  setIsFetching(true);
  fetchFindContactList({
    params: { identificatorNumber: `00000000${searchParam.numCard}` }
  }).then(response => {
    const cryptedContactList = Immutable.fromJS(response.data["hydra:member"]);
    setIsFetching(false);
    setCryptedContacts(cryptedContactList);

    if (!cryptedContactList.size) {
      setIsOpen(true);
      setIsError(true);
    }
  });
};

const onSelect = ({ setCryptedContact, saleId, fetchArticleList, fetchArticleBehaviorsList, setTotalUnitCount }) => async cryptedContact => {
  // control Max unit limit
  let totalUnits = 0;
  const articleList = await fetchArticleList({ params: { sale: saleId } });

  await Promise.all(
    articleList["hydra:member"].map(async art => {
      const articleBehaviorsList = await fetchArticleBehaviorsList({ params: { article: art.get("@id") } });

      articleBehaviorsList["hydra:member"].map(behavior => {

         const behaviorArrayId = behavior.get('behaviorId').split('/');
         const behaviorId = behaviorArrayId.pop();

         if (behaviorId === 'counter_line') {
             totalUnits += behavior.get('configuration').get('totalUnities');
         }
      });
    })
  );

  setTotalUnitCount(totalUnits + cryptedContact.get('units').get('/bluegreen/counter_units/1'));
  setCryptedContact(cryptedContact);
};

const onNotFound = ({ setIsError, setIsOpen, isError }) => () => {
  setIsError(false);
  setIsOpen(true);
};

const onResetForm = ({ clearContactSeach, setIsFetching }) => () => {
  clearContactSeach();
  setIsFetching(false);
};

const onClose = ({ setIsOpen, setIsFetching }) => () => {
  setIsOpen(false);
  setIsFetching(false);
};

const clearContactSeach = ({ setCryptedContacts, setCryptedContact, setIsOpen }) => () => {
  setCryptedContacts(Immutable.List());
  setCryptedContact(Immutable.Map());
  setIsOpen(false);
};

const onSwitchForm = ({ setNoCardIdentification, setSearchAccount, noCardIdentification, clearContactSeach }) => () => {
  setNoCardIdentification(!noCardIdentification);
  setSearchAccount({});
  clearContactSeach();
};

const onConfirmPayment = ({ history, doPayment, cryptedContact, saleId, setIsPreparePayment, clearCart }) => () => {
  setIsPreparePayment(true);
  doPayment(cryptedContact.get("contactId"), saleId).then(doPaymentResponse => {
    clearCart().then(() => {
      document.location.href = doPaymentResponse.get("redirectUrl");
    });
  });
};

export default compose(
  withProps(({ match }) => ({
    clubId: decodeParam(match.params.clubId)
  })),
  connect(null, {
    fetchFindContactList: contactApi.fetchFindContactList,
    doPayment: _doPayment,
    clearCart: _clearCart,
    fetchArticleBehaviorsList: fetchArticleBehaviorsListFn,
    fetchArticleList: fetchArticleListFn
  }),
  withState("searchAccount", "setSearchAccount", {}),
  withState("cryptedContacts", "setCryptedContacts", Immutable.List()),
  withState("cryptedContact", "setCryptedContact", Immutable.Map()),
  withState("isFetching", "setIsFetching", false),
  withState("isOpen", "setIsOpen", false),
  withState("isError", "setIsError", false),
  withState("totalUnitCount", "setTotalUnitCount", 0),
  withState("isPreparePayment", "setIsPreparePayment", false),
  withState("noCardIdentification", "setNoCardIdentification", false),
  connect(mapStateToProps),
  withHandlers({
    clearContactSeach,
    findContactsMatchingQuery,
    findContactMatchingIdentificator
  }),
  withHandlers({
    onClose,
    onSubmit,
    onSelect,
    onNotFound,
    onConfirmPayment,
    onResetForm,
    onSwitchForm
  }),
  lifecycle({ componentWillMount }),
  withTranslator
)(CheckoutAccount);



// WEBPACK FOOTER //
// ./src/app/components/CheckoutAccount/CheckoutAccountContainer.js